import { Component, Input } from '@angular/core';
import {
  DynamicFormControlType,
  DynamicFormField,
} from './dynamic-form.interfaces';

@Component({
  selector: 'app-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.scss'],
  standalone: false,
})
export class DynamicFormComponent {
  @Input() fields: DynamicFormField[] = [];

  readonly FormControlType = DynamicFormControlType;

  isOptionChecked(field: DynamicFormField, value: string): boolean {
    const current = field.formControl.value;
    return Array.isArray(current) && current.includes(value);
  }

  toggleOption(field: DynamicFormField, value: string, checked: boolean): void {
    const current: string[] = Array.isArray(field.formControl.value) ? [...field.formControl.value] : [];
    const next = checked ? [...current, value] : current.filter((v) => v !== value);
    field.formControl.setValue(next);
    field.formControl.markAsDirty();
    field.formControl.markAsTouched();
  }
}
